module.exports = __webpack_public_path__ + "img/camper_interiour_6.e8f2b995.jpg";